import { useState } from 'react'
import Star from '../assets/star.svg?react'

interface StarRatingInputProps {
    rating: number
    onRatingChange?: (rating: number) => void
    size?: number
    onRatingClicked?: (rating: number) => void
    className?: string
}

export const StarRatingInput = ({
    rating,
    onRatingChange,
    size = 32,
    onRatingClicked,
    className = '',
}: StarRatingInputProps) => {
    const [hoveredRating, setHoveredRating] = useState(0)

    const displayRating = hoveredRating || rating

    const handleClick = (value: number) => {
        if (onRatingChange) {
            onRatingChange(value)
        }
        if (onRatingClicked) {
            onRatingClicked(value)
        }
    }

    return (
        <div className={`flex ${className}`}>
            {[1, 2, 3, 4, 5].map((star) => (
                <button
                    key={star}
                    type="button"
                    onClick={() => handleClick(star)}
                    onMouseEnter={() => setHoveredRating(star)}
                    onMouseLeave={() => setHoveredRating(0)}
                    className="p-1 transition-transform hover:scale-110 cursor-pointer"
                >
                    <Star
                        width={size}
                        height={size}
                        className={
                            star <= displayRating
                                ? 'fill-yellow-400'
                                : 'fill-gray-200'
                        }
                    />
                </button>
            ))}
        </div>
    )
}
